import { useMemo } from 'react'
import { useMapStore } from '../store/mapStore'
import '../styles/MultiSelectPanel.css'

const fmt = (n) => Number(n || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 })
const dominant = (values) => {
  const counts = {}
  let best = null; let bestN = 0
  for (const v of values) {
    if (v == null || v === '') continue
    counts[v] = (counts[v] || 0) + 1
    if (counts[v] > bestN) { bestN = counts[v]; best = v }
  }
  return best
}

// Aggregated statistics over the multi-selection (Shift/Ctrl+click). Feeds
// future military planning / regional analysis. Shown only when ≥1 region held.
export default function MultiSelectPanel({ regionsData, weatherData }) {
  const selectedRegionIds = useMapStore((s) => s.selectedRegionIds)
  const clearSelectedRegions = useMapStore((s) => s.clearSelectedRegions)

  const stats = useMemo(() => {
    if (!regionsData || !selectedRegionIds.length) return null
    const idSet = new Set(selectedRegionIds)
    const feats = regionsData.features.filter((f) => idSet.has(f.properties.region_id))
    let population = 0; let area = 0
    const climates = []; const weathers = []
    const regionWeather = weatherData?.regions
    for (const f of feats) {
      const p = f.properties
      population += Number(p.population || 0)
      area += Number(p.area_km2 || 0)
      climates.push(p.climate)
      const w = regionWeather?.[p.region_id] ?? regionWeather?.[String(p.region_id)]
      weathers.push(w?.weather_type ?? p.weather_type)
    }
    return {
      count: feats.length,
      population,
      area,
      density: area > 0 ? population / area : 0,
      climate: dominant(climates),
      weather: dominant(weathers),
    }
  }, [regionsData, selectedRegionIds, weatherData])

  if (!stats) return null

  return (
    <div className="multiselect-panel pr-widget">
      <div className="multiselect-header">
        <span>{stats.count} région{stats.count > 1 ? 's' : ''} sélectionnée{stats.count > 1 ? 's' : ''}</span>
        <button type="button" onClick={clearSelectedRegions} title="Vider la sélection">×</button>
      </div>
      <div className="multiselect-grid">
        <div className="ms-stat"><span className="ms-label">Population</span><span className="ms-value">{fmt(stats.population)}</span></div>
        <div className="ms-stat"><span className="ms-label">Superficie</span><span className="ms-value">{fmt(stats.area)} km²</span></div>
        <div className="ms-stat"><span className="ms-label">Densité moy.</span><span className="ms-value">{fmt(stats.density)} hab/km²</span></div>
        <div className="ms-stat"><span className="ms-label">Climat dom.</span><span className="ms-value">{stats.climate || '—'}</span></div>
        {stats.weather && (
          <div className="ms-stat"><span className="ms-label">Météo dom.</span><span className="ms-value">{stats.weather}</span></div>
        )}
      </div>
      <p className="multiselect-hint">Maj / Ctrl + clic pour ajouter ou retirer</p>
    </div>
  )
}
